angular
    .module('tradersyard')
    .factory('exhibition-settings-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        hash = $flex.$hash.get();

                        tab = ['general', 'roles', 'blacklist'].indexOf(hash) !== -1 ? hash : 'general';

                        filter.set(tab);
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    set: function (name) {
                        tab = name;

                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);

                        if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('exhibition-settings-ctrl', [
        '$scope',
        'graph-exhibition-factory',
        'exhibition-settings-filter',
        'graph-invite-factory',
        'datetime-common',
        'graph-search-factory',
        '$flex',
        function ($scope, $factory, $filter, $invite, $common, $search, $flex) {
            $scope.node = {};
            $scope.filter = $filter;
            $scope.blacklists = {
                page: 0,
                data: [],
            };
            $scope.participants = {
                page: 0,
                data: [],
            };
            $scope.invites = {
                page: 0,
                data: [],
            };
            $scope.roles = {
                owner: {
                    page: 0,
                    data: [],
                },
                executive: {
                    page: 0,
                    data: [],
                },
                presenter: {
                    page: 0,
                    data: [],
                },
                trader: {
                    page: 0,
                    data: [],
                },
                pretrader: {
                    page: 0,
                    data: [],
                },
                listener: {
                    page: 0,
                    data: [],
                },
            };
            $scope.current_role = undefined;

            $scope.roleDictionary = {
                owner: ['owner', 'presenter', 'pretrader', 'listener'],
                presenter: ['presenter', 'pretrader', 'listener'],
            };

            $scope.user = {
                search: function ($q) {
                    $scope.participants.data = [];
                    $search
                        .entry('user')
                        .search({ params: $q })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.participants.data = response.data.data;
                            }
                        });
                },
            };
            $scope.invite = {
                search: function (q) {
                    $scope.invites.page = 0;
                    $scope.invites.data = [];
                    $scope.invite.query(q)();
                    $flex.$scroll.renew('roles');
                },
                query: function (q) {
                    return function (next) {
                        if (q === undefined || q === '') {
                            $scope.invite.find(next);
                            return;
                        }

                        ++$scope.invites.page;
                        var options = {
                            q: q,
                            page: $scope.invites.page,
                        };

                        $search
                            .place('exhibition', $scope.node.id)
                            .search('invite', { params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.invites.data = $scope.invites.data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                find: function (next) {
                    ++$scope.invites.page;
                    var options = {
                        page: $scope.invites.page,
                    };

                    $invite
                        .entry('exhibition', $scope.node.id)
                        .query({ params: options })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.invites.data = $scope.invites.data.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };
            $scope.blacklist = {
                query: function (next) {
                    var params = {
                        page: ++$scope.blacklists.page,
                    };

                    $factory
                        .blacklists($scope.node.id)
                        .query({ params: params })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.blacklists.data = $scope.blacklists.data.concat(response.data.data);
                                if (next) next();
                            }
                        });
                },
                insert: function (user) {
                    $factory
                        .blacklists($scope.node.id)
                        .insert(user.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                for (var i in $scope.participants.data) {
                                    if ($scope.participants.data[i].id === user.id) {
                                        $scope.participants.data.splice(i, 1);
                                    }
                                }
                                $scope.blacklists.data = $scope.blacklists.data.concat(user);
                            }
                        });
                },
                delete: function (user) {
                    $factory
                        .blacklists($scope.node.id)
                        .delete(user.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                for (var i in $scope.blacklists.data) {
                                    if ($scope.blacklists.data[i].id === user.id) {
                                        $scope.blacklists.data.splice(i, 1);
                                    }
                                }
                            }
                        });
                },
            };
            $scope.participant = {
                search: function (q) {
                    $scope.participants.page = 0;
                    $scope.participants.data = [];
                    $scope.participant.sQuery(q)();
                    $flex.$scroll.renew('roles');
                },
                sQuery: function (q) {
                    return function (next) {
                        if (q === '') {
                            $scope.participant.find(next);
                            return;
                        }

                        ++$scope.participants.page;
                        var options = {
                            q: q,
                            page: $scope.participants.page,
                            place: 'exhibition.' + $scope.node.id,
                        };

                        $search
                            .place('exhibition', $scope.node.id)
                            .search('participant', { params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.participants.data = $scope.participants.data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                query: function (role) {
                    if ($scope.current_role !== role) {
                        $flex.$scroll.renew('roles');
                        $scope.current_role = role;
                    }

                    return function (next) {
                        ++$scope.roles[role].page;
                        var options = {
                            roles: role,
                            page: $scope.roles[role].page,
                        };

                        $factory
                            .participants($scope.node.id)
                            .query({ params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.roles[role].data = $scope.roles[role].data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                find: function (next) {
                    $flex.$scroll.renew('roles');
                    $scope.participant.query('owner')();
                    $scope.participant.query('presenter')();
                    $scope.participant.query('pretrader')();
                    $scope.participant.query('listener')();
                },
            };

            $scope.changeMode = function (mode) {
                if (['participant', 'invite'].indexOf(mode) === -1) return;

                if (mode === $scope.ui.mode) return;

                $scope.search = '';

                switch (mode) {
                    case 'invite':
                        $scope.invites.page = 0;
                        $scope.invites.data = [];

                        $scope.invite.find();
                        break;
                    case 'participant':
                        $scope.participant.find();
                        break;
                }

                $scope.ui.mode = mode;
            };

            $scope.filter.on.change = function () {
                $flex.$scroll.switch($scope.filter.tab());
                $scope.participants.data = [];
            };

            $scope.$error = {};
            $scope.buffer = {};
            $scope.$datetime = $common;
            $scope.duration = 0;
            $scope.durationExhibition = 0;
            $scope.queue = 0;
            $scope.diffed = 0;
            $scope.diffedExhibition = 0;
            $scope.ui = {
                cancel: 0,
                mode: 'participant',
            };

            $scope.boothUrl = [];
            $scope.optionalEquipmentUrl = '';
            $scope.eventTypesUrl = '';
            $scope.boothError = [];

            $scope.booths = [];
            $scope.optionalEquipments = [];
            $scope.speakerHalls = [];
            $scope.eventTypes = [];

            $scope.languages = {
                en: false,
                de: false,
                ru: false,
            };

            $scope.addBooth = function (url, key) {
                $scope.boothError[key] = undefined;
                $scope.boothUrl[key] = '';

                $factory.addProduct(url, 'booth').then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.booths || [])
                                .map(function (booth) {
                                    if (booth && booth.id) {
                                        return booth.id;
                                    } else {
                                        return 0;
                                    }
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                $scope.booths[key] = response.data.data;
                            }
                        } else {
                            $scope.boothError[key] = response.data.data.url;
                            $scope.boothUrl[key] = url;
                        }
                    },
                    function (error) {
                        $scope.boothError[key] = 'An error occurred';
                        $scope.boothUrl[key] = url;
                    }
                );
            };

            $scope.addOptionalEquipment = function (url) {
                $scope.optionalEquipmentError = undefined;
                $scope.optionalEquipmentUrl = '';

                $factory.addProduct(url, 'optional-equipment').then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.optionalEquipments || [])
                                .map(function (booth) {
                                    return booth.id;
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                $scope.optionalEquipments = ($scope.optionalEquipments || []).concat([
                                    response.data.data,
                                ]);
                            }
                        } else {
                            $scope.optionalEquipmentError = response.data.data.url;
                            $scope.optionalEquipmentUrl = url;
                        }
                    },
                    function (error) {
                        $scope.optionalEquipmentError = 'An error occurred';
                        $scope.optionalEquipmentUrl = url;
                    }
                );
            };

            $scope.addEventType = function (url) {
                $scope.eventTypeError = undefined;
                $scope.eventTypeUrl = '';

                $factory.addProduct(url, 'event-type').then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.eventTypes || [])
                                .map(function (booth) {
                                    return booth.id;
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                response.data.data.time = 30;
                                $scope.eventTypes = ($scope.eventTypes || []).concat([response.data.data]);
                            }
                        } else {
                            $scope.eventTypeError = response.data.data.url;
                            $scope.eventTypeUrl = url;
                        }
                    },
                    function (error) {
                        $scope.eventTypeError = 'An error occurred';
                        $scope.eventTypeUrl = url;
                    }
                );
            };

            $scope.removeBooth = function (index) {
                $scope.boothUrl[index] = $scope.booths[index].url;
                $scope.booths[index] = undefined;
            };

            $scope.removeOptionalEquipment = function (index) {
                $scope.optionalEquipments.splice(index, 1);
            };

            $scope.removeEventType = function (index) {
                $scope.eventTypes.splice(index, 1);
            };

            $scope.getRandomColor = function () {
                var letters = '0123456789ABCDEF';
                var color = '#';

                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }

                return color;
            };

            $scope.addSpeakerHall = function () {
                if ($scope.speakerHalls.length < 6) {
                    $scope.speakerHalls.push({
                        name: `Speaker Hall ${$scope.speakerHalls.length + 1}`,
                        header_color: $scope.getRandomColor(),
                        background_color: $scope.getRandomColor(),
                    });
                }
            };

            $scope.removeSpeakerHall = function (index) {
                $scope.speakerHalls.splice(index, 1);
            };

            $scope.langcheck = function (code) {
                var index = $scope.node.languages.indexOf(code);

                if (index !== -1) {
                    $scope.node.languages.splice(index, 1);
                } else {
                    $scope.node.languages.push(code);
                }
            };

            $scope.is12 = $common.is12;
            $scope.is24 = $common.is24;

            $scope.calculate = function (moved) {
                $scope.node.exhibition_started_at.time = $scope.node.started_at.time;
                $scope.node.exhibition_ended_at.time = $scope.node.ended_at.time;

                var started_at = $common.gather($scope.node.started_at),
                    ended_at = $common.gather($scope.node.ended_at);
                var exhibition_started_at = $common.gather($scope.node.exhibition_started_at),
                    exhibition_ended_at = $common.gather($scope.node.exhibition_ended_at);

                if (moved === true) {
                    ended_at = started_at.clone().add($scope.diffed, 's');
                    exhibition_ended_at = exhibition_started_at.clone().add($scope.diffedExhibition, 's');
                }

                $scope.node.started_at = $common.parse(started_at);
                $scope.node.ended_at = $common.parse(ended_at);
                $scope.node.exhibition_started_at = $common.parse(exhibition_started_at);
                $scope.node.exhibition_ended_at = $common.parse(exhibition_ended_at);

                $scope.diffed = $common.diff(started_at, ended_at) / 1000;
                $scope.diffedExhibition = $common.diff(exhibition_started_at, exhibition_ended_at) / 1000;

                if ($scope.update.form.started_at_time && $scope.update.form.started_at_time.$touched) {
                    $scope.update.form.started_at_time.$setValidity('future', $common.diff(moment(), started_at) > 0);
                }

                if ($scope.update.form.ended_at_time && $scope.update.form.ended_at_time.$touched) {
                    $scope.update.form.ended_at_time.$setValidity('future', $common.diff(started_at, ended_at) > 0);
                }

                $scope.update.form.languages.$setValidity(
                    'languages',
                    Object.values($scope.languages).indexOf(true) != -1
                );

                $scope.duration = $common.duration(started_at, ended_at).humanize();
                $scope.durationExhibition = $common.duration(exhibition_started_at, exhibition_ended_at).humanize();
            };

            $scope.validate = function (data) {
                data.exhibition_started_at.time = data.started_at.time;
                data.exhibition_ended_at.time = data.ended_at.time;

                started_at = $common.gather(data.started_at);
                ended_at = $common.gather(data.ended_at);
                exhibition_started_at = $common.gather(data.exhibition_started_at);
                exhibition_ended_at = $common.gather(data.exhibition_ended_at);

                $scope.buffer = {
                    name: data.name,
                    description: data.description,
                    languages: data.languages,
                    privacy: 'public',
                    started_at: started_at.toISOString(),
                    ended_at: ended_at.toISOString(),
                    exhibition_started_at: exhibition_started_at.toISOString(),
                    exhibition_ended_at: exhibition_ended_at.toISOString(),
                    floorplan_template: data.floorplan_template,
                    booths_class_1: data.booths_class_1,
                    booths_class_2: data.booths_class_2,
                    booths_class_3: data.booths_class_3,
                    streams_class_1: data.streams_class_1,
                    streams_class_2: data.streams_class_2,
                    streams_class_3: data.streams_class_3,
                    booths_class_1_link_id: $scope.booths[1] ? $scope.booths[1].id : 0,
                    booths_class_2_link_id: $scope.booths[2] ? $scope.booths[2].id : 0,
                    booths_class_3_link_id: $scope.booths[3] ? $scope.booths[3].id : 0,
                    speaker_halls: $scope.speakerHalls,
                    booths: $scope.booths,
                    optionalEquipments: $scope.optionalEquipments,
                    eventTypes: $scope.eventTypes,
                };

                return true;
            };

            $scope.submit = function () {
                if ($scope.validate($scope.node) === true && $scope.queue === 0) {
                    $scope.queue = 1;

                    if ($scope.node.reopen) {
                        $scope.reopen($scope.buffer);
                    } else {
                        $scope.update($scope.buffer);
                    }
                }
            };

            $scope.errors = {};

            $scope.cancel = function (node) {
                $factory.cancel(node.id).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/exhibition/' + $scope.node.id);
                    }
                });
            };

            $scope.update = function (data) {
                $scope.errors = {};

                $factory.update($scope.node.id, data).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/exhibition/' + $scope.node.id);
                    } else {
                        $scope.queue = 0;
                        $scope.errors = response.data.data;
                        window.scrollTo(0, 0);
                    }
                });
            };

            $scope.node.reopen = false;

            $scope.reopen = function (data) {
                $scope.errors = {};

                data.status = 'registration';

                $factory.update($scope.node.id, data).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/exhibition/' + $scope.node.id);
                    } else {
                        $scope.queue = 0;
                        $scope.errors = response.data.data;
                        window.scrollTo(0, 0);
                    }
                });
            };

            $scope.$on('touch:general', function () {
                // angular.extend($scope.node);

                var languages = [];

                $scope.node.languages.forEach(function (code) {
                    languages.push(code.code);
                    $scope.languages[code.code] = true;
                });

                $scope.node.started_at = $common.parse(moment($scope.node.started_at));
                $scope.node.ended_at = $common.parse(moment($scope.node.ended_at));
                $scope.node.exhibition_started_at = $common.parse(moment($scope.node.exhibition_started_at));
                $scope.node.exhibition_ended_at = $common.parse(moment($scope.node.exhibition_ended_at));

                $scope.node.languages = languages;

                $factory.queryBooths($scope.node.id).then(function (response) {
                    $scope.boothsLinkIds = [
                        $scope.node.booths_class_1_link_id,
                        $scope.node.booths_class_2_link_id,
                        $scope.node.booths_class_3_link_id,
                    ];

                    response.data.data.map(function (item) {
                        [1, 2, 3].map(function (index) {
                            if ($scope.node['booths_class_' + index + '_link_id'] == item.id) {
                                $scope.booths[index] = item;
                            }
                        });
                    });
                });
                $factory.queryOptionalEquipments($scope.node.id).then(function (response) {
                    $scope.optionalEquipments = response.data.data;
                });
                $factory.queryEventTypes($scope.node.id).then(function (response) {
                    $scope.eventTypes = response.data.data;
                });

                $factory.querySpeakerHalls($scope.node.id).then(function (response) {
                    $scope.speakerHalls = response.data.data;
                });

                // setTimeout($scope.calculate, 0);
            });

            $scope.$on('touch:roles', function () {
                $scope.participant.find();
            });

            $scope.$on('touch:blacklist', function () {
                $scope.blacklist.query();
            });

            $scope.$on('$historyBack', $filter.init);
        },
    ]);
